import { Grid2 } from "@mui/material";
import React from "react";
import DisplayDetailsCard from "../../components/DisplayDetailsCard";
import defaultProfile from "../../assets/images/defaultProfile.png";

const Players = () => {
  const _onPlayerDetailsClick = () => {};
  return (
    <Grid2 container size={12}>
      {[1, 2, 3, 4, 5]?.map((ele) => (
        <Grid2 size={{ xs: 12, sm: 12, md: 4 }}>
          <DisplayDetailsCard
            onClick={_onPlayerDetailsClick}
            imageLogo={defaultProfile}
            enableShadow
          />
        </Grid2>
      ))}
    </Grid2>
  );
};

export default Players;
